export const JWT_IS_EXPIRED_ERROR_MESSAGE = "Jwt is expired";
export const ID_TOKEN = "id_token";
export const ACCESS_TOKEN = "access_token";
export const REFRESH_TOKEN = "refresh_token";
export const SUBJECT_OF_TOKEN = "sub";
export const GLOBAL_AUTH_CACHE_NAME = "authCache";
export const LOGOUT_REASON = "logoutReason";
export const LOGIN_REDIRECT = "login_redirect";